import { authHeader } from '../../../../auth';

export default {
    name: "EditFooterImages",
    data() {
        return {
            editData: [],
            imageFile: '',
            previewImage: '',
            image: '',
            id: ''
        }
    },
    async created() {
        document.title = "Dispo - Edit Footer Images";
    },
    mounted() {
        if(this.$route.params.id != undefined) {
            this.id = this.$route.params.id;
        }
        this.getData(this.id);
    },
    methods: {
        getData: async function(id) {
            let config = {
                method: "GET",
                url: this.$serverURL + this.$api.cms.footerImagesURL + '/' + id,
                headers: authHeader()
            };
            await this.$axios(config).then((response) => {
                if (response.status == 200) {
                    this.editData = response.data.data[0];
                    this.image = this.editData.image;
                }
            }).catch(error => {
                this.isLoading = false;
                this.$swal.fire({
                    icon: "error",
                    text: error.response.data.message
                });
            });
        },
        onIconChange(event) {
            this.imageFile = event.target.files[0];
            let input = this.$refs.image;
            let file = input.files;
            if (file && file[0]) {
                let reader = new FileReader;
                reader.onload = e => {
                    this.previewImage = e.target.result;
                }
                reader.readAsDataURL(file[0]);
            }
        },
        update: async function() {
            let token = localStorage.getItem('token');
            const formData = new FormData();
            formData.append("image", this.imageFile ? this.imageFile : this.image);
            let config = {
                method: "PATCH",
                url: this.$serverURL + this.$api.cms.footerImagesURL + '/' + this.id,
                data: formData,
                headers: {
                    "Authorization": "Bearer " + token,
                    "Content-Type": "multipart/form-data"
                }
            };
            await this.$axios(config).then((response) => {
                if (response.status == 200) {
                    this.$swal.fire({
                        toast: true,
                        position: 'top-end',
                        text: response.data.message,
                        icon: "success",
                        showConfirmButton: false,
                        timer: 3000,
                        animation: false,
                        timerProgressBar: true,
                        didOpen: (toast) => {
                            toast.addEventListener('mouseenter', this.$swal.stopTimer)
                            toast.addEventListener('mouseleave', this.$swal.resumeTimer)
                        }
                    });
                }
                this.previewImage = '';
                this.imageFile = '';
                this.$refs.image.value = null;
                this.$router.push("/footer-images");
            }).catch(error => {
                this.isLoading = false;
                this.$swal.fire({
                    icon: "error",
                    text: error.response.data.message
                });
            });
        }
    }
}